import axios from 'axios';
import publicId from 'public-ip';
import * as util from '../util/utils';
import siteMapping from '../util/siteMapping';

const QUIZLER_URL = process.env.QUIZLER_URL || '/api/quizler';

export const fetchResults = (indexName) => {
    return axios({
        method: 'GET',
        url: QUIZLER_URL + '/' + indexName
    })
};

export const sendResultsAndActivate = async({ email, template, results, resultsUrl, trackingVars, lists, condition, site}) => {
    const payload = {
        "email": email,
        "trackingVars": trackingVars,
        "lists": lists,
        "pillarId": siteMapping[site].pillarId,
        "ipAddress": await publicId.v4(),
        "template": template,
        "results": results,
        "resultsUrl": resultsUrl,
        "condition": condition,
        "landingPageId": siteMapping[site].landingPageId,
        "identifiers": {
            tglr_anon_id: util.getCookieValue('tglr_anon_id'),
            tglr_sess_id: util.getCookieValue('tglr_sess_id')
        },
        "site": site
    };

    return axios({
        method: 'POST',
        url: `${QUIZLER_URL}/results`,
        data: payload
    })
};